import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './DropdownTextEditorToolValue.scss';

const DropdownTextEditorToolValue = ({ value, visible = true }) => (
  <div
    className={cx(styles.value, {
      [styles.hidden]: !visible,
    })}
  >
    {value}
  </div>
);

DropdownTextEditorToolValue.propTypes = {
  value: PropTypes.number,
  visible: PropTypes.bool,
};

export default DropdownTextEditorToolValue;
